import { render, staticRenderFns } from "./Banking.html?vue&type=template&id=28e36504&scoped=true&"
import script from "./Banking.js?vue&type=script&lang=js&"
export * from "./Banking.js?vue&type=script&lang=js&"
import style0 from "./Banking.scss?vue&type=style&index=0&id=28e36504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e36504",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
